import { render, staticRenderFns } from "./research-center.vue?vue&type=template&id=6c021058&scoped=true"
import script from "./research-center.vue?vue&type=script&lang=js"
export * from "./research-center.vue?vue&type=script&lang=js"
import style0 from "./research-center.vue?vue&type=style&index=0&id=6c021058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c021058",
  null
  
)

export default component.exports